export interface DynamicConfigurations {
  dsn: string;
  sentryEnvironment: string;
  whitelabel: string;
}

export const defaultConfigurations: DynamicConfigurations = {
  dsn: '',
  sentryEnvironment: '',
  whitelabel: 'gatehouse',
};

export const configurationUrl = './configurations/config.json';
